import React from "react";
import { Drawer, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const RightDrawer = ({ open, onClose, children }) => {
    return (
        <Drawer anchor="right" open={open} onClose={onClose} sx={{ zIndex: 1400 }}>
            <Box
                sx={{
                    width: 600, // Chiều rộng của drawer
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh",
                }}
            >
                {/* Nút đóng */}
                <Box display="flex" justifyContent="flex-end">
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Nội dung bên trong drawer */}
                <Box mt={2}>{children}</Box>
            </Box>
        </Drawer>
    );
};

export default RightDrawer;
